import React from "react";

export type BarcodeScannerScreenContextType = {
  onNoProductSecondaryAction: {
    label: string;
    onPress: (barcode: string) => void;
  };
};

export const BarcodeScannerScreenContext = React.createContext<
  BarcodeScannerScreenContextType | undefined
>(undefined);
